import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgPhantom = function SvgPhantom(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 121"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#AB9FF2",
        d: "M14.2 110c15.313 0 26.82-13.327 33.689-23.858-.836 2.33-1.3 4.66-1.3 6.896 0 6.151 3.527 10.531 10.488 10.531 9.559 0 19.768-8.387 25.058-17.427q-.558 1.957-.557 3.634c0 4.287 2.413 6.99 7.332 6.99 15.498 0 31.09-27.493 31.09-51.538C120 26.496 110.534 10 86.775 10 45.012 10 0 61.072 0 94.063 0 107.018 6.96 110 14.2 110m58.19-66.822c0-4.66 2.599-7.922 6.403-7.922 3.713 0 6.311 3.262 6.311 7.922s-2.598 8.015-6.31 8.015c-3.805 0-6.404-3.355-6.404-8.015m19.86 0c0-4.66 2.6-7.922 6.404-7.922 3.713 0 6.311 3.262 6.311 7.922s-2.598 8.015-6.31 8.015c-3.806 0-6.404-3.355-6.404-8.015"
    })));
};

export { SvgPhantom as ReactComponent };
//# sourceMappingURL=Phantom.svg.es.js.map
